import { render, staticRenderFns } from "./BaseDatePicker.vue?vue&type=template&id=56b79549&scoped=true"
import script from "./BaseDatePicker.vue?vue&type=script&lang=js"
export * from "./BaseDatePicker.vue?vue&type=script&lang=js"
import style0 from "./BaseDatePicker.vue?vue&type=style&index=0&id=56b79549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b79549",
  null
  
)

export default component.exports